import axios from "@/app/plugins/Axios";
import qs from "qs";

export default new class MovimentoEstoqueService {
  listar(paginacao) {
    return axios
      .get("movimentos?" + qs.stringify(paginacao))
      .then((response) => response.data);
  }

  abrir(movimento_id) {
    return axios
      .get("/movimentos/" + movimento_id)
      .then((response) => response.data);
  }

  salvar(movimento) {
    return axios
      .post("/movimentos", movimento)
      .then((response) => response.data);
  }

  atualizar(movimento) {
    return axios
      .put("/movimentos/" + movimento.id, movimento)
      .then((response) => response.data);
  }

  excluir(movimento_id) {
    return axios
      .delete("/movimentos/" + movimento_id)
      .then((response) => response.data);
  }

  transferencias() {
    return axios
      .get("/movimentos/transferencias")
      .then((response) => response.data);
  }

  transferir(movimento) {
    return axios
      .post(`/movimentos/${movimento.id}/transferir`, movimento)
      .then((response) => response.data);
  }

  impressaoTerminca(movimento) {
    return axios
      .post(`/movimentos/${movimento.id}/impressao-termica`)
      .then((response) => response.data);
  }
};
